<template>
  <div class="p-6 loading-table" v-if="loading">
    <spinner-color />
  </div>
  <div v-else>
    <data-table-order
      :data="this.$store.state.dataList.orders"
      :header="header"
      :body="body"
      :pageName="pageName"
      :titlePage="titlePage"
      :statusForAdvancedSearch="statusForAdvancedSearch"
      :advancedSearchData="advancedSearchData"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import DataTableOrder from "../components/table-components/DataTableOrder.vue";
import SpinnerColor from "@/views/components/table-components/SpinnerColor2.vue";
import loadingTable from "@/mixins/loadingTable.js";
import allStatus from "@/views/status/orderStatus";

export default {
  mixins: [loadingTable],
  components: {
    DataTableOrder,
    SpinnerColor,
  },
  data() {
    return {
      header: [
        { header: "sentDate", key: "sent_at" },
        { header: "dueDate", key: "execution_date" },
        { header: "typeOfReturn", key: "returned_inventory_status" },
        { header: "code", key: "code" },
        { header: "sender", key: "second_client" },
        { header: "receiver", key: "receiver" },
        { header: "government", key: "gov_name" },
        { header: "area", key: "area" },
        { header: "collectedAmount", key: "amount_to_be_collected" },
        { header: "amountCollect", key: "amount" },
        { header: "amountSupplied", key: "cash_amount" },
        { header: "captain", key: "captain_name" },
        { header: "returnReason", key: "return_reason_text" },
        { header: "from", key: "previous_branch" },
        { header: "to", key: "branch_name" },
      ],
      body: [
        "sent_at",
        "execution_date",
        "returned_inventory_status",
        "code",
        "second_client",
        "receiver",
        "gov_name",
        "location",
        "amount_to_be_collected",
        "amount",
        "cash_amount",
        "captain_name",
        "return_reason_text",
        "previous_branch",
        "branch_name",
      ],
      advancedSearchData: [
        {
          label: "sentDate",
          nameToEndpoint: "sentDate",
          max: "",
          type: "date",
        },
        { label: "dueDate", nameToEndpoint: "dueDate", max: "", type: "date" },
        { label: "code", nameToEndpoint: "code", max: "", type: "text" },
        { label: "sender", nameToEndpoint: "sender", max: 15, type: "text" },
        {
          label: "receiver",
          nameToEndpoint: "receiver",
          max: 15,
          type: "text",
        },
        { label: "area", nameToEndpoint: "area", max: 13, type: "text" },
        {
          label: "collectedAmount",
          nameToEndpoint: "collectedAmount",
          max: 15,
          type: "text",
        },
        {
          label: "amountCollect",
          nameToEndpoint: "amountCollect",
          max: 15,
          type: "text",
        },
        {
          label: "amountSupplied",
          nameToEndpoint: "amountSupplied",
          max: 15,
          type: "text",
        },
        {
          label: "returnReason",
          nameToEndpoint: "returnReason",
          max: 30,
          type: "text",
        },
      ],
      statusForAdvancedSearch: 0,
      pageName: "order/returned-with-change-branch",
      titlePage: "withChangeBranch",
    };
  },
  async created() {
    this.credentials.page = "order/returned-with-change-branch";
    this.fetchData(this.credentials);
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_loadingTable.scss";
</style>
